import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { Constants } from '../../core/config/Constants';
import { SplashMap } from '../../core/models/splash-map';
import { SplashMapService } from '../../core/services/splash-map.service';
import { ContentsMandatory } from '../../core/models/contents-mandatory';

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.css'],
  providers: [SplashMapService]
})
export class SplashScreenComponent implements OnInit {

  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
  eventId: string = '';
  eventype_1: string = 'SPLASH001';
  message: string = null;
  sectionName: boolean = false;
  isError: boolean = false;
  errorMessage: Array<string> = new Array();
  prop: string = 'square';
  prop2: string;
  splash_duration: number = 1;
  disableButton = true;
  splashMap = new SplashMap();

  color: string = null;
  splashTextcolor: string= null;

  SplashSelectColorClass: string = null;


  splashColor1: string = null;
  splashColor2: string = null;
  splashColor3: string = null;
  splashColor4: string = null;
  splashtColor: string = null;

  imageFile = File;
  uploadFileName: string = null;
  uploadprogress: number = null;
  headerFileUrl: string = null;
  fileName: string = null;

  constructor(private splashMapService: SplashMapService, private router: Router, private extraService: ExtraService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let id = params['eventId'];
      if (id) {
        this.eventId = id;
        this.extraService.setCurrentEventId(id);
        this.setSplashData(id);
      }
    });
  }

  onBasicUpload(event) {
    if (event.files[0]) {
      // this.splashHeaderData.fileName = event.files[0].name;
      let uploadTask = this.splashMapService.uploadFile(this.eventId, event.files[0]);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) => {
          this.disableButton = false;
          this.message = 'File Uploading...';
          this.uploadFileName = event.files[0].filename;
          this.uploadprogress = Math.floor((uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100);
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          let contentsMandatory = new ContentsMandatory();
          contentsMandatory.category = Constants.CONTENT_M_TYPE_SPLASH;
          contentsMandatory.fileUrl = uploadTask.snapshot.downloadURL;
          contentsMandatory.eventId = this.eventId;
          contentsMandatory.filename = event.files[0].name;
          contentsMandatory.extension = event.files[0].name.split('.').pop();
          contentsMandatory.sizeInBytes = event.files[0].size;
          console.log(contentsMandatory);

          let key = this.splashMapService.addContentMandatory(contentsMandatory);
          if (key) {
            this.message = 'File Uploaded Successfully';
            this.splashMap.splash_header_image_cm_id = key;
            setTimeout(function () {
              this.message = null;
              this.disableButton = true;
            }.bind(this), 1000);
          }

        });
    }

  }

  deleteImage() { 

    this.uploadFileName = null;
    this.uploadprogress = null;

  }

  setSplashData(id: string) {
    this.splashMapService.getSplashData(id).subscribe(event => {
      if (event) {
        this.splashMap = event;
        if (event.splash_header_image_cm_id) {
          this.splashMapService.getFileUrl(this.eventId, event.splash_header_image_cm_id).subscribe(res => {
            if (res) {
              this.headerFileUrl = res.fileUrl;
              this.fileName = res.filename;
            }
          });
        }

        if (event.splash_custom_text_color) { 
          this.splashTextcolor = event.splash_custom_text_color; 
        }

        if (event.splash_custom_bg_color) { 
          this.color = event.splash_custom_bg_color; 
        }
        this.eventype_1 = this.splashMap.splash_screen_type;
        if (event.splash_duration) {
          this.splash_duration = this.splashMap.splash_duration = event.splash_duration / 1000;
        }
      }
    });
  }

  receiveColor(event) {
    if (event) {
      console.log(event);
      this.splashMap.splash_custom_bg_color = event.splash_cutom_bg_color;
    }
  }

  receiveColor2(event) {
    if (event) {
      console.log(event);
      this.splashMap.splash_custom_text_color = event.splash_cutom_bg_color;
    }
  }

  receiveHeaderEvent($eventHeader) {
    if ($eventHeader) {
      if(!$eventHeader.disableButton && $eventHeader.fileName == null) {

        console.log($eventHeader.disableButton)

      } else if(!$eventHeader.disableButton && $eventHeader.fileName != null) {

        console.log($eventHeader.disableButton)
        this.message = "File Uploading...";
        this.disableButton = false;

      } else if($eventHeader.disableButton && $eventHeader.fileName != null ) {

        this.message = "File Uploaded Successfully";
        this.disableButton = true;
        this.splashMap.splash_header_image_cm_id = $eventHeader.splash_header_image_cm_id;
        
      }

      this.splashMap.splash_header_text_top = $eventHeader.splash_header_text_top;
      this.splashMap.splash_header_text_bottom = $eventHeader.splash_header_text_bottom;
      this.splashMap.splash_has_header_text_top = $eventHeader.splash_has_header_text_top;
      this.splashMap.splash_has_header_text_bottom = $eventHeader.splash_has_header_text_bottom;
      
    } 

  }

  receiveFooterEvent($eventFooter) {
    if ($eventFooter) {
      console.log($eventFooter)

      if(!$eventFooter.disableButton && $eventFooter.fileName == null) {
        
        console.log($eventFooter.disableButton)

      } else if(!$eventFooter.disableButton && $eventFooter.fileName != null) {

        console.log($eventFooter.disableButton)
        this.message = "File Uploading...";
        this.disableButton = false;

      } else if($eventFooter.disableButton && $eventFooter.fileName != null ) {
        console.log($eventFooter.disableButton ,$eventFooter.fileName)
        this.message = "File Uploaded Successfully";
        this.disableButton = true;
        this.splashMap.splash_footer_image_cm_id = $eventFooter.splash_footer_image_cm_id;

      }

      this.splashMap.splash_footer_text_top = $eventFooter.splash_footer_text_top;
      this.splashMap.splash_footer_text_bottom = $eventFooter.splash_footer_text_bottom;
      this.splashMap.splash_has_footer_text_top = $eventFooter.splash_has_footer_text_top;
      this.splashMap.splash_has_footer_text_bottom = $eventFooter.splash_has_footer_text_bottom;
      
    } 
  }


  submit() {

    console.log(this.splashMap);

    this.disableButton = false;
    this.isError = false;
    this.message = null;
    this.errorMessage = new Array();
    this.splashMap.splash_screen_type = this.eventype_1;
    if (this.splash_duration) {
      this.splashMap.splash_duration = Math.floor(this.splash_duration * 1000);
    }
    let splashMap = this.splashMap;
    console.log(splashMap)
    this.splashMapService.addSplashMap(this.eventId, splashMap).then(res => {
      this.message = "updated successfully";

      setTimeout(function () {
        this.message = null;
        this.disableButton = true;
      }.bind(this), 2000);

    }).catch(error => {
      this.isError = true;
      this.errorMessage.push(error.message);
      this.disableButton = true;
    });
  }


  /*splashColorChange(splashtColor: string) {
    this.SplashSelectColorClass = 'add-color';
    this.clearSplashColor();
    this.splashMap.splash_cutom_text_color = splashtColor;
  }*/

  /*getsplashColor(value) {
    if (value) {
      console.log(value);
      this.SplashSelectColorClass = null;
      this.splashtColor = null;
      this.splashMap.splash_cutom_text_color = value;
    }
  }*/

  /*clearSplashColor() {
    this.splashColor1 = null;
    this.splashColor2 = null;
    this.splashColor3 = null;
    this.splashColor4 = null;
  }*/

}





// WEBPACK FOOTER //
// /app/src/app/event/splash-screen/splash-screen.component.ts